import script from "./FAQModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQModal.vue?vue&type=script&setup=true&lang=js"

import "./FAQModal.vue?vue&type=style&index=0&id=09a4e149&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a4e149"]])

export default __exports__